import { buildTranslate } from 'locales'
import { Fields as UserEvent } from 'models/UserEvent'
import { TransactedEvent } from 'models/UserEvent'
import { Fields as UserReward } from 'models/UserReward'

const t = buildTranslate('users.view.activity')

export function rewardIssuanceDescription(reward: UserReward): string | null {
  switch (reward.issuance_type) {
    case 'granted':
      return t('rewards.issuance_description.granted')
    case 'intro':
      return t('rewards.issuance_description.intro')
    default:
      return null
  }
}

export function getEventDescription(event: UserEvent): string | null {
  switch (event.type) {
    case 'reward_intro_delivered':
    case 'reward_ongoing_delivered':
    case 'reward_vip_delivered':
    case 'reward_used':
      return rewardIssuanceDescription(event.related_item)
    case 'transacted':
      return transactedDescription(event.related_item)
    default:
      return null
  }
}

function transactedDescription(
  item: TransactedEvent['related_item']
): string | null {
  if (item.granted) {
    return t('overview.table.manually_added')
  }

  return null
}

/**
 * Filter out reward_used events for static points rewards.
 * Static points rewards generate both a delivery event and a used event,
 * but we only want to show the delivery event to avoid confusion.
 *
 * @param events - Array of user events to filter
 * @returns Filtered array of events with static points reward_used events removed
 */
export function filterStaticPointsRewardUsed(events: UserEvent[]): UserEvent[] {
  return events.filter(event => {
    if (event.type === 'reward_used' && event.related_item) {
      const rewardItem = event.related_item as { redeem_type?: string }
      return rewardItem.redeem_type !== 'points_static'
    }
    return true
  })
}

/**
 * AI-1291 (FR-61): drop order_rating_submitted rows from the Activity
 * overview stream for an operator without ratings-and-reviews (Feedback)
 * view permission. The rest of the stream is unaffected — this degrades the
 * stream, it doesn't block it, mirroring the server's own treatment of
 * GET /users/:identifier/events (N4).
 */
export function filterOrderRatingEvents(
  events: UserEvent[],
  canViewFeedback: boolean
): UserEvent[] {
  if (canViewFeedback) return events
  return events.filter(event => event.type !== 'order_rating_submitted')
}
